import { Button } from '@material-ui/core';
import React from 'react';
import { USE_GST_VERIFY, VERIFY_GST_API_SECRET_KET } from './config.service';


export function showSnackbar(snackbar: any, text: string, okayBtn: boolean = true, duration?: number) {
    const key = snackbar.enqueueSnackbar(text, {
        ...(duration && {autoHideDuration: duration}),
        action: () => (
            <>
                {
                    okayBtn
                    ?
                        <Button style={{color: '#fff'}} onClick={() => snackbar.closeSnackbar(key)}>
                            Okay
                        </Button>
                    :
                        null
                }
            </>
        )
    })
}

export function showSuccessSnackbar(snackbar: any, text: string, okayBtn: boolean = true, duration?: number) {
    const key = snackbar.enqueueSnackbar(text, {
        ...(duration && {autoHideDuration: duration}),
        variant: 'success',
        action: () => (
            <>
                {
                    okayBtn
                    ?
                        <Button style={{color: '#fff'}} onClick={() => snackbar.closeSnackbar(key)}>
                            Okay
                        </Button>
                    :
                        null
                }
            </>
        )
    })
}

export function showErrorSnackbar(snackbar: any, text: string, okayBtn: boolean = true, duration?: number) {
    const key = snackbar.enqueueSnackbar(text, {
        ...(duration && {autoHideDuration: duration}),
        variant: 'error',
        action: () => (
            <>
                {
                    okayBtn
                    ?
                        <Button style={{color: '#fff'}} onClick={() => snackbar.closeSnackbar(key)}>
                            Okay
                        </Button>
                    :
                        null
                }
            </>
        )
    })
}

export function verifyGST(gstin: any) {

    // To disable GST Verify during dev
    if(USE_GST_VERIFY) {
        return new Promise((resolve, reject) => {
            fetch(`https://appyflow.in/api/verifyGST?gstNo=${gstin}&key_secret=${VERIFY_GST_API_SECRET_KET}`)
            .then(res => res.json())
            .then(data => {
                if(data.error === true) {
                    resolve(false)
                } else {
                    resolve(true)
                }
            })
        })
    } else {
        return new Promise((resolve, reject) => {
            if(gstin === '03ACDPM7062M1ZH') {
                resolve(true);
            } else {
                resolve(false);
            }
        })
    }
}
// export function verifyGST(gstin: any) {
    // return new Promise((resolve, reject) => {
    //     if(gstin === '03ACDPM7062M1ZH') {
    //         resolve(true);
    //     } else {
    //         resolve(false);
    //     }
    // })
// }


export function formatDate(date: any) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

export function formatDateInDDMMYYYY(date: Date) {
    // var date = new Date();
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
}


export function getHeaderForPrint(data: any, invoice:any = false) {
    console.log(data);
    return`
            <div style="width: 425px">
                <div style="width: 100%; ${invoice !== false||true? '': 'border: 0.5px solid #000;'} display: flex; font-size: 6px;">
                    <div style="line-height: 1em;width: 50%;${invoice !== false ? 'border: 0.5px solid #000; border-bottom: none;': ''} padding: 6px">
                        <div>${data.user.name}</div>
                        <div>${data.user.addressLine1} </div>
                        <div>${data.user.addressLine2}</div>
                        <div>${data.user.addressLine3}</div>
                        <div>CELL - ${data.user.mobile}</div>
                        <div>GSTIN / UIN - ${data.user.gstin} </div>
                        <div>State Name: ${data.user.state}, Code: ${data.user.code} </div>
                    </div>
                    ${
                        invoice !== false
                        ?
                            `
                            <div style="width: 50%; display: flex; flex-direction: column;">
                                <div style="width: 100%; display: flex; height: 50%">
                                    <div style="border-top: 0.5px solid #000;border-right: 0.25px solid #000; flex: 1; padding: 6px">
                                        <div>Invoice No. </div>
                                        <div>${data.invoice.number}</div>
                                    </div>
                                    <div style="border-top: 0.5px solid #000; border-right: 0.5px solid #000; flex: 1; padding: 6px">
                                        <div>Date </div>
                                        <div>${formatDate(data.invoice.date).split('-').reverse().join('-')}</div>
                                    </div>
                                </div>
                                <div style="display: flex; flex: 1">
                                    <div style="border-top: 0.5px solid #000;border-right: 0.25px solid #000; flex: 1; padding: 6px"">
                                        <div>Dispatch through </div>
                                    </div>
                                    <div style="border-top: 0.5px solid #000; border-right: 0.5px solid #000; flex: 1; padding: 6px"">
                                        <div>Vehicle No.</div>
                                        <div>${data.user.lastVehicleNo}</div>
                                    </div>
                                </div>
                            </div>
                            `
                        :
                            ''
                    }
                </div>
                ${
                    invoice !== false
                    ?
                        `<div style="width: 100%; display: flex; font-size: 6px;">
                            <div style="line-height: 1em;width: 50%; border-top: 0.5px solid #000; border-left: 0.5px solid #000;border-bottom: 0.5px solid #000; border-right: 0.5px solid #000; padding: 6px">
                                Buyer: <br />
                                <div>${data.customer.companyName}</div>
                                <div>${data.customer.address}</div>
                                <div>GSTIN: ${data.customer.gstin} </div>
                                <div>E-Mail: ${data.customer.email} </div>
                            </div>
                            <div style="width: 50%; border-top: 0.5px solid #000; border-bottom: 0.5px solid #000; border-right: 0.5px solid #000; padding: 6px">
                                Terms of delivery. <br />
                                We are not responsible for any loss, Shortage Damage <br />
                                Delay, etc in transit 12% interest will be added if not <br />
                                payment is made with in one week.
                            </div>
                        </div>`
                    :
                        ''
                }
            </div>
            `;
}